import { Col, Row } from 'antd'
import DocumentUpload from 'app/components/Core/Document/Upload'
import KForm from 'app/components/Modules/Form/KForm'
import { RecordType } from 'app/constants/GlobalTypes'
import { useState } from 'react'
import * as React from 'react'

import { MemberProps } from '../convention'
import RentalSelect from '../Rental/Select'

const ProjectDocumentList: React.FC<MemberProps<IProject>> = ({ member }) => {
  const [rentalId, setRentalId] = useState(null)

  return (
    <Row>
      <Col span={24}>
        <KForm hideSubmit recordType={RecordType.project} layout="vertical">
          <RentalSelect
            onChange={setRentalId}
            params={{
              filters: {
                project_ids: [member.id]
              }
            }}
            hasExtra={true}
          />
        </KForm>
      </Col>
      <Col span={24}>
        <DocumentUpload
          props={{ model_id: rentalId, document_type: 'other', model_type: 'Rental' }}
          disabled={!rentalId}
        />
      </Col>
    </Row>
  )
}

export default ProjectDocumentList
